import React from 'react';
import ImgixComponent, { SharedImigixAndSourceProps } from 'react-imgix';

import NoPhotoImg from 'img-src/static/nophotos.png';
import { isLocalImage, isContentfulImage } from './imageSource';
import { useImgix } from './useImgix';

type ImgixSizes = Omit<SharedImigixAndSourceProps, 'width' | 'height'> & {
  sizes: string;
};

type ImgixWidth = Omit<SharedImigixAndSourceProps, 'sizes'> & {
  width: number;
};

type ImgixProps = (ImgixSizes | ImgixWidth) & {
  fallbackSrc?: string;
};

export const Imgix: React.FC<ImgixProps> = props => {
  const { transformImageURL } = useImgix();
  const [fallback, setFallback] = React.useState<boolean>(false);

  const showFallback = React.useCallback(() => {
    setFallback(true);
  }, [setFallback]);

  const { src = NoPhotoImg, fallbackSrc = NoPhotoImg } = props;
  if (
    isLocalImage(props.src) ||
    isContentfulImage(props.src) ||
    !props.src ||
    fallback
  ) {
    return (
      // eslint-disable-next-line jsx-a11y/alt-text
      <img
        data-test-locator="imgix"
        {...props}
        src={fallback ? fallbackSrc : src || fallbackSrc}
        onError={showFallback}
      />
    );
  }

  return (
    <ImgixComponent
      {...props}
      htmlAttributes={{
        'data-test-locator': 'imgix',
        onError: showFallback,
        ...props.htmlAttributes,
      }}
      src={transformImageURL(src)}
    />
  );
};
